import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GameService, GameState } from '../../shared/services/game.service';
import { APP_ROLE, SocketService } from '../../shared/services/socket.service';
import { StorageService } from '../../shared/services/storage.service';


@Injectable()
export class CanActivateDigiGame implements CanActivate {
  constructor(private _socketService: SocketService, private _gameService: GameService, private _storageService: StorageService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this._gameService.state === GameState.START) {
      return Observable.of(true);
    } else {
      if (this._gameService.state === GameState.PREPARE) {
        return this._storageService.getSessionCode().map( (sessionCode) => {
          if (sessionCode == null) {
            return Observable.of(false);
          } else {
            if (this._socketService.connected === false) {
              this._gameService.sessionCode = sessionCode;
              this._socketService.initSocket(sessionCode, APP_ROLE.DIGI_ROLE);

              const onConnection = this._socketService.onDigiConnection().map(() => {
                return true;
              });
              const onError = this._socketService.onSocketError().map(() => {
                return false;
              });

              return Observable.merge(onConnection, onError).take(1);
            } else {
              return Observable.of(true);
            }
          }
        }).flatMap( (e: Observable<boolean>) => {
          return e.map( (val) => {
            if ( val === true ) {
              return true;
            } else {
              this._router.navigate(['/digi/connect']);
              return false;
            }
          });
        });

      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/digi/digi-game/can-activate.guard.ts